import { useEffect, useState } from "react";

/**
 * Returns `true` once the browser has had a chance to paint at least once.
 * Use to gate non-critical providers/widgets so their JS chunk is deferred
 * until after first contentful paint, keeping LCP and TBT clean.
 */
export function useAfterPaint(): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const w = window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number };
    if (typeof w.requestIdleCallback === "function") {
      const id = w.requestIdleCallback(() => setReady(true), { timeout: 1500 });
      return () => (window as any).cancelIdleCallback?.(id);
    }
    const t = window.setTimeout(() => setReady(true), 200);
    return () => window.clearTimeout(t);
  }, []);
  return ready;
}
